import { render, staticRenderFns } from "./DeviceDetailsReviews.vue?vue&type=template&id=d74a2f6e"
import script from "./DeviceDetailsReviews.vue?vue&type=script&lang=js"
export * from "./DeviceDetailsReviews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports